/**
  Axios interceptors and configuration.
*/

import axios from 'axios';

axios.defaults.baseURL = window.ACC.config.encodedContextPath;

require('./toast-interceptor');
